import { Inject, Injectable } from "@angular/core";
import { TokenClaimsService } from "src/modules/app/auth/token-claims.service";
import { CONNECTOR_MANAGEMENT_API, IS_VIRTUAL_CONNECTOR } from "src/modules/app/variables";

@Injectable({
  providedIn: 'root',
})
export class ManagementRouteService {
  constructor(
    private readonly tokenClaims: TokenClaimsService,
    @Inject(CONNECTOR_MANAGEMENT_API) private readonly managementApiUrl: string,
    @Inject(IS_VIRTUAL_CONNECTOR) private readonly isVirtualConnector: boolean
  ) {
  }

  public getManagementBaseUrl(): String {
    if (this.isVirtualConnector) {
      return this.getVirtualConnectorUrl();
    }

    return this.getStandardConnectorUrl();
  }

  private getVirtualConnectorUrl(): String {
    const participantContextId = this.tokenClaims.getParticipantContextId();
    if (!participantContextId) {
      console.warn('AssetService: participant_context_id claim is missing from the token.');
      throw new Error('Cannot determine participant context ID from token claims.');
    }
    
    const base = this.managementApiUrl.replace(/\/$/, '');
    return `${base}/v5beta/participants/${encodeURIComponent(participantContextId)}`;
  }

  private getStandardConnectorUrl(): String {
    return `${this.managementApiUrl}/v3`;
  }
}